function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#696969",
  d: "M2.683 1.083h12.634c.731 0 1.215.474 1.215 1.215v8.747c0 .74-.484 1.215-1.215 1.215H7.542a.486.486 0 0 0-.341.136l-2.817 2.817v-2.468a.486.486 0 0 0-.486-.485H2.683c-.731 0-1.215-.475-1.215-1.215V2.298c0-.74.484-1.215 1.215-1.215zm0-.972C1.472.111.496 1.076.496 2.298v8.747c0 1.222.976 2.186 2.187 2.186h.729v3.159a.486.486 0 0 0 .827.342l3.5-3.5h7.578c1.211 0 2.187-.965 2.187-2.187V2.298A2.175 2.175 0 0 0 15.317.111z"
})));

var SvgReplyIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReplyIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reply-icon.4f68ee5e.svg";
export { ForwardRef as ReactComponent };